import React, { ReactNode } from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	padding: '12px',
	background: '#FFF9E6',
	border: '1px solid #FFBE00',
	borderRadius: '8px',
	letterSpacing: '0.28px',
	gap: '10px',
	'& .bold': {
		fontSize: '16px',
		fontWeight: 'bold',
		color: 'var(--default-text-color)',
	},
	'& .link': {
		fontSize: '16px',
		fontWeight: 'bold',
		color: '#5E94FF',
		textDecoration: 'underline',
		cursor: 'pointer',
	},
	'@media screen and (max-width: 600px)': {
		flexDirection: 'column',
		alignItems: 'flex-start',
		//@ts-ignore
		'& .link, & .bold': {
			fontSize: '13px',
		},
		p: {
			fontSize: '13px',
		},
	},
});

interface Props {
	children: ReactNode;
}

const HighlightedInfo: React.FC<Props> = ({ children }) => {
	return <StyledContainer>{children}</StyledContainer>;
};

export default HighlightedInfo;
